import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../common/utils';

@Pipe({
  name: 'formatoNumeros'
})
export class FormatoNumerosPipe implements PipeTransform {

  transform(numero:string,decimales:number=2): string {
    if (decimales == 0) {  return Utils.decimalFormat(numero,decimales ,'.', '', 2); }
    return Utils.decimalFormat(numero,decimales ,'.', ',', 2)
  }

}
